export default __webpack_public_path__ + "static/media/5.9ce9e1f4.png";